import { Base64 } from 'js-base64';

/**
 * Encodes the card object as Base64 string, so it can be sent over the network
 * @param {Object} card - the card object
 */
/* eslint-disable import/prefer-default-export */
export function encodeCardAsBase64(card) {
  return Base64.encodeURI(JSON.stringify(card));
}
